export const isExistingMediaSelection = (previewImage) =>
  previewImage?.type === "existing" && previewImage?.mediaId;

export const resolvePublicMediaUrl = (url, apiUrl) => {
  if (!url) return "";
  const value = String(url).replace(/\\/g, "/").trim();
  if (/^https?:\/\//i.test(value)) return value;
  let base = String(apiUrl || "").replace(/\/$/, "");
  const path = value.replace(/^\/+/, "");
  // Media-library files are served at /uploads on the site, not under /api.
  if (
    path.startsWith("uploads/media/") ||
    path.startsWith("uploads/restaurant_")
  ) {
    base = base.replace(/\/api$/, "");
  }
  return base ? `${base}/${path}` : `/${path}`;
};

export const getPreviewImageSrc = (previewImage, apiUrl) => {
  if (!previewImage) return null;
  if (previewImage instanceof File) {
    return URL.createObjectURL(previewImage);
  }
  if (isExistingMediaSelection(previewImage)) {
    return resolvePublicMediaUrl(previewImage.url, apiUrl);
  }
  return null;
};

export const getImageFormFields = (previewImage, fieldName = "image") => {
  if (!previewImage) return {};
  if (previewImage instanceof File) {
    return { [fieldName]: previewImage };
  }
  if (isExistingMediaSelection(previewImage)) {
    return { mediaId: previewImage.mediaId };
  }
  return {};
};

export const appendImageFormFields = (
  formData,
  previewImage,
  fieldName = "image"
) => {
  const fields = getImageFormFields(previewImage, fieldName);
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return Object.keys(fields).length > 0;
};

export function handleFullscreen(src, type) {
    const fullscreenElement = document.createElement(
        type === "video" ? "video" : "img"
    );
    fullscreenElement.src = src;
    fullscreenElement.style.position = "fixed";
    fullscreenElement.style.top = 0;
    fullscreenElement.style.left = 0;
    fullscreenElement.style.width = "100vw";
    fullscreenElement.style.height = "100vh";
    fullscreenElement.style.objectFit = "contain";
    fullscreenElement.style.backgroundColor = "black";
    fullscreenElement.style.zIndex = 9999;

    if (type === "video") {
        fullscreenElement.controls = true;
        fullscreenElement.autoplay = true;
    }

    document.body.appendChild(fullscreenElement);

    const closeFullscreen = () => {
        fullscreenElement.remove();
    };

    fullscreenElement.onclick = closeFullscreen;
};